"use strict";

var _defineProperty = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/defineProperty.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throughData = void 0;

var throughData = function throughData(data) {
  var tmpData = {};

  if (data.datas) {
    data.datas.forEach(function (tmp) {
      var result = (0, exports.throughData)(tmp);
      Object.keys(result).forEach(function (temp) {
        if ('object' === typeof temp) {
          Object.keys(temp).forEach(function (key) {
            tmpData[key] = temp[key];
          });
        } else {
          tmpData[temp] = result[temp];
        }
      });
    });
  }

  if (data.name) {
    return _defineProperty({}, data.name, Object.keys(tmpData).length > 0 ? tmpData : true === data.required);
  }

  return tmpData;
};

exports.throughData = throughData;

var requiredData = function requiredData(datas) {
  var objet = {};
  var result = (0, exports.throughData)(datas);
  Object.keys(result).forEach(function (temp) {
    if ('object' === typeof temp) {
      Object.keys(temp).forEach(function (key) {
        objet[key] = temp[key];
      });
    } else {
      objet[temp] = result[temp];
    }
  });
  return objet;
};

exports.default = requiredData;